import React from 'react';
import styled from 'styled-components';

interface CheckboxProps {
    checked?: boolean;
    onChange: (newCheckedState: boolean) => void;
    disabled?: boolean;
    id?: string;
    name?: string;
    value?: string;
}

const CheckboxContainer = styled.div`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`;

const StyledCheckbox = styled.div<{ checked: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 2px solid #ddd;
    border-radius: 3px;
    background-color: ${props => props.checked ? '#007bff' : '#fff'};
    border-color: ${props => props.checked ? '#007bff' : '#ddd'};
    transition: all 0.2s ease;

    &:hover {
        border-color: #007bff;
    }
`;

const CheckIcon = styled.div<{ checked: boolean }>`
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: ${props => props.checked ? 'block' : 'none'};
`;

export function FilterCheckBox({ checked = false, onChange, disabled = false, id, name, value }: CheckboxProps) {
    const handleContainerClick = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            onChange(event.target.checked);
        }
    };

    return (
        <CheckboxContainer onClick={handleContainerClick}>
            <HiddenCheckbox
                checked={checked}
                onChange={handleCheckboxChange}
                disabled={disabled}
                id={id}
                name={name}
                value={value}
            />
            <StyledCheckbox checked={checked}>
                <CheckIcon checked={checked} />
            </StyledCheckbox>
        </CheckboxContainer>
    );
}